<template>
  <div class="flex flex-wrap items-center gap-y-1 py-1">
    <div
      v-for="(entry, index) in entries"
      :key="`ring-${entry.card.id}`"
      class="cursor-pointer rounded-full"
      :class="{'-ml-1': index > 0}"
      :style="{zIndex: entry.card.id === selectedId ? 30 : 10 + (entries.length - index)}"
      :title="tooltip(entry)"
      @click="$emit('select', entry.card)"
    >
      <loyalty-card-ring
        :state="entry.analysis.state"
        :percent="entry.analysis.percent"
        :initials="entry.analysis.initials"
        :logo="entry.analysis.logoUrl"
        :gradient="entry.analysis.gradient"
        :selected="entry.card.id === selectedId"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import {DetectionLoyaltyCard} from "@/notification/interfaces";
import LoyaltyCardRing from "@/notification/components/notification-detection/loyalty-cards/LoyaltyCardRing.vue";
import {DetectionCardEntry} from "@/notification/components/notification-detection/loyalty-cards/detectionCardAnalysis";

const props = defineProps<{
    /** The laboratory card entries, already sorted and analyzed. */
    entries: DetectionCardEntry[];
    selectedId: number | null;
}>();

defineEmits<{
    select: [card: DetectionLoyaltyCard];
}>();

const tooltip = (entry: DetectionCardEntry): string => {
    if (entry.analysis.state === "inactive") {
        return `${entry.analysis.shortName} · non activée`;
    }

    const label = `${entry.analysis.shortName} · ${entry.analysis.fillLabel ?? ""}`.trim();

    return entry.card.id === props.selectedId ? `${label} · cliquer pour ouvrir` : label;
};
</script>
